<template>
  <b-modal
    v-model="trigger"
    :centered="true"
    :no-close-on-backdrop="dontCloseWhenClickedOutside"
    :no-close-on-esc="dontCloseWhenEscapePressed"
    :hide-header-close="dontShowCloseIcon"
    :hide-footer="true"
    :hide-header="true"
    @cancel="eventCancel($event)"
  >
    <div class="empanel-modal-close">
      <span v-if="!isEdit" class="Modal-head-text">Add Contact</span>
      <span v-if="isEdit" class="Modal-head-text">Edit Contact</span>
      <p class>
        <img
          @click="closeContactModal()"
          class="cursor-pointer modal-close-button mt-n1"
          style="float:right"
          src="@/assets/images/close1.svg"
        />
      </p>
    </div>
    <div class="card contact-card">
      <div class="col-10 mt-3">
        <w-text-input
          class="text-left ml-5"
          :defaultValue="contactForm.name"
          :labelName="$t('Name')"
          @textInputChange="getContactName($event)"
          :validation="'required'"
          :type="'text'"
          :allowOnlyCharacters="true"
          :maxCharacter="'100'"
        />
      </div>
      <div class="col-10">
        <w-text-input
          class="text-left ml-5"
          :defaultValue="contactForm.designation"
          :labelName="$t('Designation')"
          @textInputChange="getContactDesignation($event)"
          :validation="'required'"
          :type="'text'"
          :allowOnlyCharacters="true"
          :maxCharacter="'100'"
        />
      </div>
      <div class="col-10">
        <b-form-group class="source-sans-pro text-left ml-5" label="Department">
          <w-dropdown
            class="width-control-small"
            :options="contactDepartment"
            @dropdownChange="getContactDepartment($event)"
            :selected="contactForm.departmentCode"
          />
        </b-form-group>
      </div>
      <div class="col-10" v-if="contactForm.departmentCode == 6">
        <w-text-input
          class="text-left ml-5"
          :defaultValue="contactForm.department"
          :labelName="$t('Department Name')"
          @textInputChange="getContactDepartmentName($event)"
          :validation="'required'"
          :type="'text'"
          :maxCharacter="'100'"
          :allowOnlyCharacters="true"
        />
      </div>
      <div class="col-10">
        <w-text-input
          class="text-left ml-5"
          :defaultValue="contactForm.mobileNumber"
          :labelName="$t('Mobile Number')"
          @textInputChange="getContactMobile($event)"
          :validation="mobileValidationObj()"
          :type="'number'"
          :inputAdditions="'mobile'"
          :maxDigits="'15'"
          :isdCode="phoneNumberCode"
        />
      </div>
      <div class="col-10">
        <w-text-input
          class="text-left ml-5"
          :defaultValue="contactForm.email"
          :labelName="$t('Email')"
          @textInputChange="getContactEmail($event)"
          :validation="'required|email'"
          :maxCharacter="'100'"
          :type="'text'"
        />
        <p
          class="ml-5 font-weight-bold text-danger lato-regular"
          v-if="restrictEmail"
        >Email ID of this domain is Restricted!</p>
      </div>
      <div class="col-10">
        <b-form-group class="source-sans-pro text-left ml-5" label="Contact Category">
          <w-dropdown
            class="width-control-small"
            :options="contactCategories"
            @dropdownChange="getContactCategories($event)"
            :selected="contactForm.contactCategory"
          />
        </b-form-group>
      </div>
      <div class="row mt-3 mr-1">
        <!-- <div class="col-8"></div> -->
        <div class="col">
          <b-button
            v-if="!isEdit"
            class="ml-2 button-class"
            :disabled="checkContactAllFields()"
            @click="saveContact(isEdit)"
          >Save</b-button>
          <b-button
            v-if="isEdit"
            class="ml-2 button-class"
            :disabled="checkContactAllFields()"
            @click="saveContact(isEdit)"
          >Update</b-button>
        </div>
      </div>
    </div>
    <w-loadingSpinner :loadSpinner="loading" />
  </b-modal>
</template>
<script>
import TextInput from "./TextInput";
import DropDown from "../widgets/DropDown";
import loadingSpinner from "../widgets/LoadingSpinner";
import { OnBoardingServices } from "../services/onBoardingService";
import { PartnerService } from "../services/partnerService";
// import VeeValidate from "vee-validate";
const OnBoardingService = new OnBoardingServices();
const partnerService = new PartnerService();
import { RegistrationService } from "../services/RegistrationService.js";
const RegisterService = new RegistrationService();

export default {
  components: {
    "w-text-input": TextInput,
    "w-dropdown": DropDown,
    "w-loadingSpinner": loadingSpinner
  },
  props: [
    "trigger",
    "dontCloseWhenClickedOutside",
    "dontShowCloseIcon",
    "dontCloseWhenEscapePressed",
    "editContacts",
    "isEdit",
    "categoryCode"
  ],
  created() {
    this.getPartnerInfo();
    this.getDropDownValues();
    this.getContactCategoryDropdown();
    this.contactForm.departmentCode = 0;
    if (this.isEdit) {
      console.log("Created Contact", this.editContacts);
      // this.contactForm = this.editContacts;
      console.log("Edit is called", this.contact);
      this.contactForm.slNo = this.editContacts.slNo;
      this.contactForm.name = this.editContacts.name;
      this.contactForm.designation = this.editContacts.designation;
      this.contactForm.departmentCode = this.editContacts.departmentCode;
      this.contactForm.department = this.editContacts.department;
      this.contactForm.mobileNumber = this.editContacts.mobileNumber;
      this.contactForm.email = this.editContacts.email;
      this.contactForm.contactCategory = this.editContacts.category;
      this.contactForm.documentNumber = this.editContacts.documentNo;
      // this.contactDepartment.forEach(element => {
      //   if (element.text == this.editContacts.department) {
      //     this.contactForm.departmentCode = element.value;
      //   }
      // });
    }
    // this.getDefaultDropDownValue();
  },
  computed() {
    console.log(this.contact);
  },
  data() {
    return {
      contactForm: {
        companyCode: "",
        categoryCode: "",
        slNo: "",
        name: "",
        designation: "",
        departmentCode: "",
        department: null,
        mobileNumber: "",
        contactCategory: "",
        email: ""
      },
      contactDepartment: [],
      contactCategories: [],
      phoneNumberCode: 91,
      phoneNumberLength: 10,
      companycode: "",
      loading: false,
      restrictEmail: false
    };
  },
  methods: {   
    mobileValidationObj(){
      if(!this.$root.isInternational){
        return {required: true, regex_mobile_number: true, length: this.phoneNumberLength}
      } else {
        return {required: true, min:6}
      }     
    },
    getContactCategoryDropdown() {
      let dropdownValues = [
        { value: "P", text: "Primary" },
        { value: "S", text: "Secondary" }
      ];
      this.contactCategories = dropdownValues;
    },
    checkContactAllFields() {
      if (
        this.contactForm.name &&
        this.contactForm.designation &&
        this.contactForm.departmentCode &&
        this.contactForm.mobileNumber &&
        this.contactForm.email &&
        this.contactForm.contactCategory &&
        this.errors.items.length == 0 &&
        this.restrictEmail == false
      ) {
        if (this.contactForm.departmentCode == 6) {
          if (this.contactForm.department) {
            return false;
          } else {
            return true;
          }
        }
        return false;
      } else {
        return true;
      }
    },
    getPartnerInfo() {
      partnerService.getPartnerInfo().then(resp => {
        this.companycode = resp.response.currentCompanyCode;
        this.$root.isInternational =
              resp.response.countryDetail.countryCode == 100 ? false : true;
              this.phoneNumberCode = resp.response.countryDetail.isdCode;
        this.phoneNumberLength = 
        resp.response.countryDetail.sizeOfMobileNumber ? 
        resp.response.countryDetail.sizeOfMobileNumber : 15;
        // this.categoryCode = resp.response.currentCategoryCode;
      });
    },
    getDropDownValues() {
      OnBoardingService.getContactDepartment().then(resp => {
        this.contactDepartment.push({
          value: 0,
          text: "Select one",
          disabled: true
        });
        resp.response.forEach(department => {
          let dropdownValues = {
            value: department.departmentCode,
            text: department.longDesc
          };
          this.contactDepartment.push(dropdownValues);
        });
        console.log("department", this.contactDepartment);
      });
    },
    // emptyContact() {
    //   this.contactForm.slNo = "";
    //   this.contactForm.name = "";
    //   this.contactForm.designation = "";
    //   this.contactForm.departmentCode = "";
    //   this.contactForm.departmentName = "";
    //   this.contactForm.mobile = "";
    //   this.contactForm.email = "";
    // },
    getContactDepartmentValue() {
      if (this.isEdit == true) {
        this.contactDepartment.forEach(element => {
          if (element.text == this.editContacts.departmentName) {
            console.log(
              "getContactDepartmentValue",
              this.editContacts.departmentName,
              element.value
            );
            return element.value;
          }
        });
      } else {
        return this.contactForm.departmentCode;
      }
    },
    closeContactModal(event) {
      // this.emptyContact();
      //   console.log(this.contact);
      this.$emit("eventClose", event);
    },
    getContactName(event) {
      this.contactForm.name = event;
    },
    getContactDesignation(event) {
      this.contactForm.designation = event;
    },
    getContactDepartment(event) {
      this.contactForm.departmentCode = event;
    },
    getContactDepartmentName(event) {
      this.contactForm.department = event;
    },
    getContactMobile(event) {
      this.contactForm.mobileNumber = event;
    },
    getContactEmail(event) {
      this.contactForm.email = event;
      var domain = event.replace(/.*@/, "");
      var domainName = domain.split(".");
      let emailRegex = new RegExp("^[a-zA-Z0-9+._-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,6}$");
      if (emailRegex.test(event.toLowerCase()) && domainName[0]) {
        RegisterService.restrictEmail(domainName[0]).then(resp => {
          if (resp.response == false) {
            this.restrictEmail = true;
          } else {
            this.restrictEmail = false;
          }
        });
      }
    },
    getContactCategories(event) {
      this.contactForm.contactCategory = event;
    },
    saveContact(isEdit) {
      this.loading = true;
      this.contactForm.categoryCode = this.categoryCode;
      this.contactForm.companyCode = this.companycode;
      if (isEdit) {
        if (this.contactForm.departmentCode != 6) {
          this.contactForm.department = "";
        }
        partnerService
          .contactDraft(this.contactForm)
          .then(res => {
            if (res.response) {
              this.loading = false;
              this.$emit("afterSave");
              this.isEdit = false;
            }
            if (res.failureMessage) {
              this.$emit("alertOnSave", res.failureMessage); 
                window.alert(res.failureMessage);
              this.loading = false;
            }
          })
          .catch(e => {
                window.alert("Something went wrong! try again later");
            this.loading = false;
          });
      } else {
        partnerService
          .contactDraft(this.contactForm)
          .then(res => {
            if (res.response) {
              this.loading = false;
              this.$emit("afterSave");
            }
            if (res.failureMessage) {
              this.$emit("alertOnSave", res.failureMessage); 
                window.alert(res.failureMessage);
              this.loading = false;
            }
          })
          .catch(e => {
                window.alert("Something went wrong! try again later");
            this.loading = false;
          });
      }
    }
  }
};
</script>
<style scoped>
.empanel-modal-close {
  padding: 8px !important;
  background-image: linear-gradient(to bottom, #1d76ae, #055396);
  border: 0.1px;
}
.empanel-modal-close {
  padding: 8px !important;
  background-image: linear-gradient(to bottom, #1d76ae, #055396);
  border: 0.1px;
}
.empanel-modal-close {
  padding: 8px !important;
  background-image: linear-gradient(to bottom, #1d76ae, #055396);
  border: 0.1px;
}
.contact-card {
  /* width: 300px; */
}
.button-class {
  width: 100px;
  height: 30px;
  font-family: "Source Sans Pro", sans-serif;
  font-size: 14px;
  color: white !important;
  border-radius: 2px;
  background-color: #1579ab;
  margin-bottom: 30px;
  display: block;
  margin-left: auto !important;
  margin-right: auto !important;
}
.button-class:disabled {
  color: white !important;
}
</style>